import { NavLink, Outlet } from "react-router-dom";
import { Avatar, type AvatarShape } from "../../components/Avatar.js";
import { Brandmark } from "../../components/Brandmark.js";
import { Icon } from "../../components/Icon.js";
import { useUser } from "../../auth/UserContext.js";
import { logoutUrl } from "../../auth/authClient.js";
import type { KidBundle } from "../../api/me.js";

const TABS: ReadonlyArray<{ id: string; label: string; icon: string }> = [
  { id: "home", label: "Home", icon: "home" },
  { id: "goals", label: "Goals", icon: "target" },
  { id: "allowance", label: "Allowance", icon: "piggy" },
  { id: "history", label: "History", icon: "history" },
  { id: "send", label: "Send", icon: "transfer" },
  { id: "learn", label: "Learn", icon: "sparkle" },
];

export default function KidLayout() {
  const { bundle } = useUser();
  if (!bundle || bundle.user.role !== "kid") return null;
  const kid = bundle as KidBundle;

  const onLogout = () => {
    window.location.href = logoutUrl();
  };

  return (
    <div className="app">
      <div className="topbar">
        <div className="topbar-brand">
          <Brandmark />
          KBank
        </div>
        <div className="topbar-user">
          <div className="topbar-greet">
            <span className="small">Signed in as</span>
            <span className="name">{kid.user.name}</span>
          </div>
          <Avatar
            kid={{
              name: kid.user.name,
              color: kid.user.color ?? "var(--brand)",
              avatarShape: (kid.user.avatarShape as AvatarShape) ?? "circle",
            }}
            size={40}
          />
          <button className="btn btn-ghost btn-sm" onClick={onLogout}>
            <Icon name="logout" size={16} />
            Sign out
          </button>
        </div>
      </div>

      <div className="nav">
        {TABS.map((t) => (
          <NavLink key={t.id} to={t.id} className={({ isActive }) => (isActive ? "active" : "")}>
            <Icon name={t.icon} size={16} />
            {t.label}
          </NavLink>
        ))}
      </div>

      <div className="main fadein">
        <Outlet />
      </div>
    </div>
  );
}
